var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.1562 0.8125H1.84375C1.05273 0.8125 0.4375 1.45703 0.4375 2.21875V12.5312C0.4375 13.3223 1.05273 13.9375 1.84375 13.9375H5.85742V9.48438H4.01172V7.375H5.85742V5.79297C5.85742 3.97656 6.94141 2.95117 8.58203 2.95117C9.40234 2.95117 10.2227 3.09766 10.2227 3.09766V4.88477H9.31445C8.40625 4.88477 8.11328 5.44141 8.11328 6.02734V7.375H10.1348L9.8125 9.48438H8.11328V13.9375H12.1562C12.918 13.9375 13.5625 13.3223 13.5625 12.5312V2.21875C13.5625 1.45703 12.918 0.8125 12.1562 0.8125Z"}));
}

Facebook.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 14 14","fill":"currentColor"};

module.exports = Facebook;

Facebook.default = Facebook;
